export enum StatisticalAnalysisViewDetailChartTypeChartsTypes {
    COLUMN = 'columns',
    STACKED_COLUMNS = 'stackedColumns',
    BARS = 'bars',
    STACKED_BARS = 'stackedBars',
    RADIAL = 'radial'
}

export interface StatisticalAnalysisViewDetailChartTypeChartsModel {
    id: StatisticalAnalysisViewDetailChartTypeChartsTypes
    name: string
    pathImage: string
}

export interface StatisticalAnalysisViewDetailChartTypeChartsState {
    sidepanelVisible: boolean
    loading: boolean
    selected: StatisticalAnalysisViewDetailChartTypeChartsTypes
    charts: StatisticalAnalysisViewDetailChartTypeChartsModel[]
}
export const initialStatisticalAnalysisViewDetailChartTypeChartsState =
    (selected: StatisticalAnalysisViewDetailChartTypeChartsTypes): StatisticalAnalysisViewDetailChartTypeChartsState => ({
        sidepanelVisible: false,
        loading: false,
        selected,
        charts: [
            {
                id: StatisticalAnalysisViewDetailChartTypeChartsTypes.COLUMN,
                name: 'statisticalAnalysis.sidepanels.columnsBasic',
                pathImage: require('@/assets/images/graphics/column-basic-graphic.png')
            },
            {
                id: StatisticalAnalysisViewDetailChartTypeChartsTypes.STACKED_COLUMNS,
                name: 'statisticalAnalysis.sidepanels.columnsStacked',
                pathImage: require('@/assets/images/graphics/column-stacked-graphic.png')
            },
            {
                id: StatisticalAnalysisViewDetailChartTypeChartsTypes.BARS,
                name: 'statisticalAnalysis.sidepanels.barsBasic',
                pathImage: require('@/assets/images/graphics/bar-basic-graphic.png')
            },
            {
                id: StatisticalAnalysisViewDetailChartTypeChartsTypes.STACKED_BARS,
                name: 'statisticalAnalysis.sidepanels.barsStacked',
                pathImage: require('@/assets/images/graphics/bar-stacked-graphic.png')
            },
            {
                id: StatisticalAnalysisViewDetailChartTypeChartsTypes.RADIAL,
                name: 'statisticalAnalysis.sidepanels.barsRadial',
                pathImage: require('@/assets/images/graphics/bar-radial-graphic.png')
            }
        ]
    })
